// ** Third Party Components
import styled, { css } from "styled-components";

// ** Custom Components
import { Icon } from "components/icons";

// #####################################################

export const StyledSvgIconContainer = styled.div`
	display: flex;
	${({ customMargin }) =>
		customMargin &&
		css`
			margin: ${customMargin};
		`}

	${({ $customAlignItems }) =>
		$customAlignItems &&
		css`
			align-items: ${$customAlignItems};
		`}


	svg {
		display: inline-block;
		vertical-align: middle;

		${({ customFill }) =>
			customFill &&
			css`
				fill: ${({ theme: { colors } }) => colors[customFill]};
			`}
	}
`;

// #####################################################

const DynamicHeartIcon = ({
	solid,
	height,
	width,
	customMargin,
	customFill,
	customAlignItems,
}) => {
	return (
		<StyledSvgIconContainer
			customMargin={customMargin}
			customFill={customFill}
			$customAlignItems={customAlignItems}
		>
			<Icon
				name="heart"
				variant={solid ? "solid" : "regular"}
				height={height}
				width={width}
			/>
		</StyledSvgIconContainer>
	);
};

// #####################################################

export default DynamicHeartIcon;

// #####################################################
